//字符存在返回 ，号分隔的字符串
export function thereAre(str) {

    if (str) {
        if (str.slice(str.length - 1, str.length) === ',') {
            return str.slice(0, str.length - 1)
        }
        else {
            return str ? str.toString() : ''
        }
    }
    return '';

}

// 分割字符串，返回 ，号分隔的字符串
export function splitStr(str) {
    let arr = str.trim().split(' ')

    let r = []
    arr.forEach((m, i) => {
        if (m) {
            r.push(m)
        }
    })
    return r.join()
}

//  input失焦去除空格加逗号
export function blurFormatter(value) {
    return value && value.trim().replace(/\s+/g,',')
}

export function debounce(func, wait = 100) {
    let timeout, result;

    return function () {
        let context = this;
        let args = arguments;

        clearTimeout(timeout)
        timeout = setTimeout(function () {
            result = func.apply(context, args)
        }, wait);

        return result;
    }
}


export function throttle(fn, delayTime = 100) {
    /**
     * 节流方法，delayTime单位为毫秒
     * 当前文件的 tableHeaderFixed【table头部悬浮】有使用案例
     *
     */
    let preTime = Date.now();
    return function () {
        let _this = this;
        let args = arguments;
        let nowTime = Date.now();
        if (nowTime - preTime >= delayTime) {
            fn.apply(_this, args);
            preTime = Date.now();
        }
    }
}


export function fixedTableHeader(scrollView, isCollapse) {
    let elTable = Array.from(scrollView.querySelectorAll('.el-table'));
    if (!elTable) return;

    elTable.forEach(el => {
        // 多表格悬浮
        if (!el.classList.contains('cancelFixedTop') && !install.isDialogTable(el)) {
            // console.log('el',el)
            let tableHeaderWrapper = el.querySelector('.el-table__header-wrapper');
            if (tableHeaderWrapper) {


                let distanceHeadHeight = tableHeaderWrapper.getBoundingClientRect().height;
                // let distanceTop = el.getBoundingClientRect().top;
                let tableBodyWrapper = el.querySelector('.el-table__body-wrapper');
                let el_table__row = el.querySelector('.el-table__fixed-header-wrapper');//头部全选
                let el_table__fixed_body_wrapper = el.querySelector('.el-table__fixed-body-wrapper')
                let vTop = scrollView.getBoundingClientRect().top; // scrollView距离顶部的距离
                let vbottom = scrollView.getBoundingClientRect().bottom; // scrollView距离底部的距离
                // let elHeight = el.offsetHeight; // table 的自身高度

                let headerBtnList = document.querySelector('.headerBtnList')
                let distanceTop = scrollView.querySelector('.el-scrollbar__view').getBoundingClientRect().top;
                let distanceBottom = scrollView.querySelector('.el-scrollbar__view').getBoundingClientRect().bottom;
                let elHeight = scrollView.querySelector('.el-scrollbar__view').offsetHeight; // scrollView 的自身高度

                let el_pagination = scrollView.querySelector('.el-pagination');

                const w = tableBodyWrapper.offsetWidth !== 0 ? tableBodyWrapper.offsetWidth + 'px' : null;

                if(!document.querySelector('.el-table')) return;
                const tableLeft = document.querySelector('.el-table').getBoundingClientRect().left
                const headerLeft = document.querySelector('table.el-table__header').getBoundingClientRect().left

                if (distanceTop <= vTop && distanceTop >= -elHeight + vTop) {
                    if (el_table__row) {//区分是否有头部
                        el_table__row.classList.add("y-table-hide")
                        el_table__fixed_body_wrapper.style.top = 0;
                    }
                    if (tableHeaderWrapper) {
                        tableHeaderWrapper.classList.add('fixedTop');
                        tableHeaderWrapper.style.top = vTop + 50 + 'px';
                        let tempInsert = install.getEle('temp-insert', el)
                        if (tempInsert.length < 1) {
                            let insert = install.createEle('div', 'temp-insert', 'height:' + distanceHeadHeight + 'px');
                            el.insertBefore(insert, tableHeaderWrapper);
                            insert = null;
                        }
                    }
                    if (headerBtnList && headerBtnList.querySelector('.el-form--inline')) {
                        headerBtnList.classList.add('fixedTop');
                        headerBtnList.classList.add('toolBarFixed');
                        headerBtnList.style.top = vTop + 'px';
                        headerBtnList.querySelector('.el-form--inline').style.padding = '4px'
                        headerBtnList.style.left = document.querySelector('.el-table__header-wrapper').offsetLeft + 'px'
                    }
                    const logoWidth = document.getElementsByClassName('logo')[0].getBoundingClientRect().width
                    if (logoWidth < 100) {
                        document.querySelector('table.el-table__header').style.marginLeft = `${tableLeft - 74}px`
                    } else {
                        document.querySelector('table.el-table__header').style.marginLeft = `${tableLeft - 220}px`
                    }

                    const otherTable = document.getElementsByClassName('otherTable')[0]
                    if (otherTable) {
                        document.querySelector('table.el-table__header').style.marginLeft = `0px`
                    }

                    headerBtnList.style.width = w

                } else {
                    if (el_table__row) {
                        el_table__row.classList.remove("y-table-hide")
                        el_table__fixed_body_wrapper.style.top = el_table__row.offsetHeight + 'px'
                    }

                    if (tableHeaderWrapper) {
                        tableHeaderWrapper.classList.remove('fixedTop');
                        let insertDom = install.getEle('temp-insert', el);

                        if (insertDom.length > 0) {
                            el.removeChild(insertDom[0]);
                        }
                    }
                    if (headerBtnList) {
                        headerBtnList.classList.remove('fixedTop');
                        headerBtnList.classList.remove('toolBarFixed');
                        headerBtnList.querySelector('.el-form--inline').style.padding = '0px'
                    }

                    document.querySelector('table.el-table__header').style.marginLeft = '0px'

                }

                if (distanceBottom >= vbottom + 50) {
                    if (el_pagination) {
                        el_pagination.classList.add('paginationFixed');
                        const scrollViewWidth = document.querySelector('.scrollView').getBoundingClientRect().width
                        el_pagination.style.width = Number(el.offsetLeft) > 180 ? `${scrollViewWidth + 75}px` : Number(scrollViewWidth) - 20 + 'px'
                    }
                } else {
                    if (el_pagination) {
                        el_pagination.classList.remove('paginationFixed');
                        el_pagination.style.width = 'auto'
                    }
                }

                tableHeaderWrapper.style.width = w
            }
        }
    })
}

let install = {
    isTable: true,//是否为table中input
    getEle: function (targetClassName, targetParent) {
        /**
         * 获取指定class元素
         *
         */
        //console.log(targetClassName, targetParent)
        targetParent = targetParent || document;
        let tartget = targetParent.getElementsByClassName(targetClassName);

        if (tartget) {
            return Array.from(tartget)
        } else {
            return []
        }

    },
    createEle(ele, cls, sty) {
        let c = document.createElement(ele);
        if (cls) {
            c.setAttribute('class', cls)
        }
        if (sty) {
            c.setAttribute('style', sty)
        }

        return c
    },
    handleElementUIPopper: function () {

        /***
         * 处理element滚动时，select不动
         *
         */


        let inputIsFocus = this.getEle('.is-focus')[0];


        // close-table-select
        if (!inputIsFocus) return;//有聚焦
        let avueCrud = this.getEle('.close-table-select');
        if (avueCrud.length < 1) {
            avueCrud = null;
            return
        }//有指定的table

        let avueCrudFocus = this.getEle('.is-focus', avueCrud[0]);
        if (avueCrudFocus.length < 1) {
            avueCrudFocus = null;
            return
        }//不是table中的

        if (avueCrud && avueCrud.length > 0 && avueCrudFocus && avueCrudFocus.length > 0) {
            avueCrudFocus[0].click()

        }

        inputIsFocus = null;
        avueCrud = null;
        avueCrudFocus = null;


    },
    isDialogTable(ele) {
        // 查询是否属于dialog中的table
        if (ele) {
            const ele_parent = ele.parentNode;
            const is_origin = ele_parent.classList.contains('el-dialog__wrapper');
            if (is_origin) {
                // 属于dialog内table
                return true;

            } else {
                // 不属于
                //console.log('父类dom', is_origin)
                //容错处理， 到父类scrollView||avue-main停止
                if (ele_parent.classList.contains('scrollView')) return false;
                if (ele_parent.classList.contains('avue-main')) return false;
                return this.isDialogTable(ele_parent);
            }
        }


    }
};


export function tableHeaderFixed() {
    /*
        控制table的header悬浮顶部
  
    */

    let scrollView = document.querySelector('.scrollView');

    if (!scrollView) return;
    if (scrollView) {
        window.addEventListener('scroll', debounce(function () {
            // 表格头部悬浮
            fixedTableHeader(scrollView, false);
            // 表格内选项隐藏
            install.handleElementUIPopper();
        }, 50), true);

        // 页面缩放，控制头部长度
        window.onresize = debounce(function () {
            fixedTableHeader(scrollView);
            install.handleElementUIPopper();
        }, 50)
    }

}


// json格式数据转换为antd select 插件的数据格式
export function toSelectOptions(data = [], valueKey, textKey, str = false, text = "label") {
    if (Array.isArray(data)) {
        return data.map(item => ({ value: str ? `${item[valueKey]}` : item[valueKey], [text]: item[textKey] })) || [];
    }
    return [];
}

// 数组格式数据转换为antd select 插件的数据格式
export function arrayToSelectOptions(data = []) {
    if (Array.isArray(data)) {
        return data.map(item => ({ value: item, text: item })) || [];
    }
    return [];
}

export function arrToJoin(data) {
    if(Array.isArray(data)) {
        return data.join(',')
    } else {
        return data
    }
}

export function getSearchDataIndex(searchData,key) {
    let keyIndex = 0
    searchData.forEach((item,index)=>{
        if(item.key === key){
            keyIndex = index
            return
        }
    })
    return keyIndex
}


  // 清空json空值属性
// undeleteConfig，配置无需删除的字段，格式 key: true
export function deleteJsonEmptyProps(json, undeleteConfig = {}) {
    if (!undeleteConfig) { undeleteConfig = {} };
    const newJson = {};
    // eslint-disable-next-line guard-for-in
    for (const key in json) {
        if (undeleteConfig[key]) { // 配置无需删除的字段直接跳出循环
        newJson[key] = json[key];
        continue;
        }

        if (json[key] || json[key] === 0) {
        if (Array.isArray(json[key]) && json[key].length > 0) {
            newJson[key] = json[key];
        } else if (typeof json[key] === 'object' && Object.keys(json[key]).length > 0) {
            newJson[key] = json[key];
        } else if (typeof json[key] === 'string' && json[key].replace(/\s/g, '') !== '') {
            newJson[key] = json[key].trim();
        } else if (typeof json[key] === 'number') {
            newJson[key] = json[key];
        } else if (typeof json[key] === 'boolean') {
            newJson[key] = json[key];
        }
        }
    }
    return newJson;
}

// 把对象转为url参数
export function urlEncode(param) {
    let newParam = '?' +
    Object.keys(param)
    .map(key => `${key}=${param[key]}`)
    .join('&')
    return newParam
}
/**
 * @param fileName 保存的文件名 
 * @param str 文件base64
 * 
 */
 export function ToExcel(fileName, str) {
    var raw = window.atob(str);
    var uInt8Array = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    const link = document.createElement("a");
    const blob = new Blob([uInt8Array], {
        type: 'application/vnd.ms-excel'
    })

    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
}

export function getUrlParams(url) {
    // 通过 ? 分割获取后面的参数字符串
    let urlStr = url.split('?')[1]
    // 创建空对象存储参数
	let obj = {};
    // 再通过 & 将每一个参数单独分割出来
	let paramsArr = urlStr.split('&')
	for(let i = 0,len = paramsArr.length;i < len;i++){
        // 再通过 = 将每一个参数分割为 key:value 的形式
		let arr = paramsArr[i].split('=')
		obj[arr[0]] = arr[1];
	}
	return obj
}
